import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="confirm-action"
export default class extends Controller {
  static values = { 
    message: String, 
    url: String, 
    method: String 
  }

  confirm(event) {
    event.preventDefault()
    
    if (confirm(this.messageValue)) {
      // Создаем форму для отправки запроса с правильным HTTP методом
      const form = document.createElement('form')
      form.method = 'POST'
      form.action = this.urlValue
      
      // Добавляем CSRF токен
      const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')
      if (csrfToken) {
        const tokenInput = document.createElement('input')
        tokenInput.type = 'hidden'
        tokenInput.name = 'authenticity_token'
        tokenInput.value = csrfToken
        form.appendChild(tokenInput)
      }
      
      // Добавляем метод для Rails (например, DELETE)
      if (this.methodValue && this.methodValue.toUpperCase() !== 'POST') {
        const methodInput = document.createElement('input')
        methodInput.type = 'hidden'
        methodInput.name = '_method'
        methodInput.value = this.methodValue.toUpperCase()
        form.appendChild(methodInput)
      }
      
      // Отправляем форму
      document.body.appendChild(form)
      form.submit()
    }
  }
}
